export interface EmployeePutRequest {
  id: number;
  employeeCode: string;
  name: string;
  password: string;
  isDairen: boolean;
  isAdmin: boolean;
}

export const EmptyEmployeePutRequest: EmployeePutRequest = {
  id: 0,
  employeeCode: '',
  name: '',
  password: '',
  isDairen: false,
  isAdmin: false,
};
